import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import wadeIcon from "../../../components/Icons/wadeIcon.svg";
import { Button, Modal } from "react-bootstrap";
import QRCode from "qrcode.react";
import CodeVerificationDialog from "../CodeVerifiaction/CodeVerificationDialog";
import { setIsAuthorized } from "../../../redux/login/actions";
import VerifiedAccount from "../../../components/Login/Message/VerifiedAccount/VerifiedAccount";
import { safeReadUsers } from "../../../services/auth/loginRetry";

export interface MicrosoftAuthenticationProps {
  show: boolean;
  email: string;
  password: string;
  user_id: number;
  onHide: any;
  qrValue: string;
}

const MicrosoftAuthenticatorDialog = (props: MicrosoftAuthenticationProps) => {
  const { show, onHide, email, password, user_id, qrValue } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [codeVerificationDialog, setCodeVerificationDialog] = useState(false);
  const [onSubmit, SetOnSubmit] = useState(false);

  const onGetCodeButtonClickHandler = () => {
    onHide();
    setCodeVerificationDialog(true);
  };

  const onDoneButtonClick = () => {
    safeReadUsers(email, password).then((response) => {
      if (response.is_verified === false) {
        navigate("/");
        SetOnSubmit(false);
      } else {
        dispatch(setIsAuthorized(true));
        // navigate("/onboard");
        navigate("/home");
      }
    });
  };

  const onCloseIconClick = () => {
    SetOnSubmit(false);
    dispatch(setIsAuthorized(true));
    // navigate("/onboard");
    navigate("/home");
  };

  const handleSuccessSubmit = () => {
    setCodeVerificationDialog(false);
    SetOnSubmit(!onSubmit);
  };

  return (
    <div>
      <Modal
        show={show}
        backdrop="static"
        keyboard={false}
        onHide={onHide}
        centered
        contentClassName="tw-bg-transparent tw-border-none tw-shadow-none"
        dialogClassName="tw-max-w-xl tw-mx-4 tw-w-full md:tw-mx-auto"
      >
        <div className="tw-bg-white tw-rounded-2xl tw-shadow-2xl tw-overflow-hidden tw-flex tw-flex-col tw-relative">
          {/* Top Accent Line */}
          <div className="tw-h-2 tw-bg-gradient-to-r tw-from-[#03234a] tw-to-[#04346c] tw-w-full"></div>

          <div className="tw-p-6 md:tw-p-10 tw-flex tw-flex-col tw-items-center">
            {/* Logo */}
            <div className="tw-mb-8 tw-bg-gray-50 tw-p-4 tw-rounded-full tw-shadow-sm">
              <img src={wadeIcon} alt="WADE Logo" className="tw-h-8" />
            </div>

            {/* Title / Instruction */}
            <h2 className="tw-text-[#03234a] tw-text-2xl tw-font-bold tw-mb-6 tw-text-center">
              Scan the QR code
            </h2>

            {/* QR Code */}
            <div className="tw-mb-8 tw-p-4 tw-bg-white tw-rounded-xl tw-border-2 tw-border-gray-100 tw-shadow-inner">
              <QRCode value={qrValue} size={180} />
            </div>

            {/* Action Button */}
            <Button
              className="tw-w-full tw-max-w-sm tw-h-12 tw-bg-[#03234a] tw-text-white tw-font-bold tw-tracking-wide tw-rounded-xl hover:tw-bg-[#052d5e] focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-offset-2 focus:tw-ring-[#03234a] disabled:tw-opacity-50 disabled:tw-cursor-not-allowed tw-transition-all tw-shadow-lg hover:tw-shadow-xl hover:-tw-translate-y-0.5 active:tw-translate-y-0"
              onClick={onGetCodeButtonClickHandler}
            >
              Ok, done!
            </Button>
          </div>
        </div>
      </Modal>
      {codeVerificationDialog && (
        <CodeVerificationDialog
          show={codeVerificationDialog}
          handleSuccessSubmit={handleSuccessSubmit}
          email={email}
          password={password}
          user_id={user_id}
          verifyType="microsoft"
          length={6}
        />
      )}
      {onSubmit && (
        <VerifiedAccount
          show={onSubmit}
          onHide={onCloseIconClick}
          onDoneButtonClick={onDoneButtonClick}
        />
      )}
    </div>
  );
};
export default MicrosoftAuthenticatorDialog;
